export default "__VITE_PUBLIC_ASSET__bad7cf59__"